module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/postgresql.d7c985e7.svg";